export enum StripeBalanceTransactionStatus {
    PENDING = 'pending',
    AVAILABLE = 'available'
  }